// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "497dc6faa7b3493a","396": "49714e16ff8e3997","460": "bc83ea653eb6a609","498": "dcfcc7c7cd0638a9","917": "23d9062e7d7513b1","985": "b0bb71edb7e70872",}[chunkId] + ".chunk.js"
}